import {RipuliamoFabbricaView} from "./ripuliamo-fabbrica.view";
export default RipuliamoFabbricaView;
